const IconEdit = ({ className }) => {
    return (
        <svg
            width='22'
            height='22'
            viewBox='0 0 22 22'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path
                d='M10.0833 3.66666H3.66668C3.18045 3.66666 2.71413 3.85982 2.37031 4.20363C2.0265 4.54745 1.83334 5.01377 1.83334 5.5V18.3333C1.83334 18.8196 2.0265 19.2859 2.37031 19.6297C2.71413 19.9735 3.18045 20.1667 3.66668 20.1667H16.5C16.9862 20.1667 17.4526 19.9735 17.7964 19.6297C18.1402 19.2859 18.3333 18.8196 18.3333 18.3333V11.9167'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M16.9583 2.29167C17.323 1.92699 17.8176 1.72212 18.3333 1.72212C18.8491 1.72212 19.3437 1.92699 19.7083 2.29167C20.073 2.65634 20.2779 3.15094 20.2779 3.66667C20.2779 4.18239 20.073 4.67699 19.7083 5.04167L11 13.75L7.33334 14.6667L8.25001 11L16.9583 2.29167Z'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default IconEdit;
